module.exports = __webpack_public_path__ + "static/img/mzingo-logo.0511d811.svg";